<template>
    <div class="containerBox">
        <div class="zxkc_tile">合作交流</div>
        <div class="zxkc_content">
            <div class="zxkc_content_left">
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '合作交流' ? 'zxkc_content_left_item_active' : ''" @click="changeType('合作交流')">合作交流
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '新闻动态' ? 'zxkc_content_left_item_active' : ''" @click="changeType('新闻动态')">新闻动态
                </div>
            </div>
            <div class="zxkc_content_center"></div>
            <div v-if="showList" style="width:min-content">
                <div class="zxkc_content_right_type1" v-if="type == '合作交流' && listShow.length > 0">
                    <div class="zxkc_content_right_mp4" v-if="listShow.length > 0">
                        <div class="news_item" v-for="(item, index) in  listShow" @click="toDetail(index)">
                            <div class="news_item_img" v-if="item.imgUrl != null && item.imgUrl != ''"><img
                                    style="height: 100%; width: 100%; object-fit: cover;  border-radius: 9px 0px 0px 9px;"
                                    :src="getUrl + item.imgUrl"
                                     /></div>
                                    <div class="news_item_img" v-else><img style="height: 100%; width: 100%; object-fit: cover;  border-radius: 9px 0px 0px 9px;"
                                        src="../images/newsmr.png"  /></div>


                            <div style="width: 70%;   margin-left: 20px;">
                                <div class="news_item_title">
                                    <div style="width: 75%;font-size: 19px;color: #333333;">{{ item.title }}</div>
                                    <div style="width: 15%;font-size: 15px;color: #666666;">{{
                        parseDate(item.happenTime) }}</div>
                                </div>
                                <div class="zxkc_content_right_ppt_item_line">
                                </div>
                                <div style="width: 100%;height: 100px;font-size: 15px;color: #333333; margin-top: 20px;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"
                                    v-html="item.content"> </div>
                            </div>
                        </div>
                        <div class="el_pagination">
                            <el-pagination background layout="prev, pager, next" :page-size="3" :total="total"
                                @current-change="pageChange">
                            </el-pagination>
                        </div>
                    </div>
                    <div v-else
                        style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                        <img style="height: 50%; width: 40%; object-fit: cover;" src="../images/bgk.jpg" />

                    </div>
                </div>
                <div class="zxkc_content_right_type1" v-if="type == '新闻动态' && listShow.length > 0">
                    <div class="zxkc_content_right_mp4" v-if="listShow.length > 0">
                        <div class="news_item" v-for="(item, index) in  listShow" @click="toDetail(index)">
                            <div class="news_item_img" v-if="item.imgUrl != null && item.imgUrl != ''"><img
                                    style="height: 100%; width: 100%; object-fit: cover;  border-radius: 9px 0px 0px 9px;"
                                    :src="getUrl + item.imgUrl"
                                     /></div>
                                    <div class="news_item_img" v-else><img style="height: 100%; width: 100%; object-fit: cover;  border-radius: 9px 0px 0px 9px;"
                                        src="../images/newsmr.png"  /></div>
                            <div style="width: 70%;   margin-left: 20px;">
                                <div class="news_item_title">
                                    <div style="width: 75%;font-size: 19px;color: #333333;">{{ item.title }}</div>
                                    <div style="width: 15%;font-size: 15px;color: #666666;">{{
                        parseDate(item.happenTime) }}</div>
                                </div>
                                <div class="zxkc_content_right_ppt_item_line">
                                </div>
                                <div style="width: 100%;height: 100px;font-size: 15px;color: #333333; margin-top: 20px;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;"
                                    v-html="item.content"></div>
                            </div>
                        </div>
                        <div class="el_pagination">
                            <el-pagination background layout="prev, pager, next" :page-size="3" :total="total"
                                @current-change="pageChange">
                            </el-pagination>
                        </div>
                    </div>
                    <div v-else
                        style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                        <img style="height: 50%; width: 40%; object-fit: cover;" src="../images/bgk.jpg" />

                    </div>
                </div>
            </div>
            <div class="zxkc_content_right_type1" v-else style="padding-top: 20px;">
                <div style="display: flex; height: 30px;">
                    <div @click="showList = true" style="color: #1C8577;font-size: 19px;cursor: pointer;"><i
                            class="el-icon-arrow-left"></i>返回</div>
                </div>
                <div style="display: flex; margin-top: 30px; ">
                    <div style="color: #333333; font-size: 19px; width: 90%; text-align: center;">{{
                        listShow[showIndex].title }}</div>
                    <div style="color: #666666;font-size: 15px;">{{ listShow[showIndex].happenTime }}</div>
                </div>
                <div v-html="listShow[showIndex].content"
                    style="color: #333333; height: 90vh; overflow: auto; margin-top: 30px;"></div>
            </div>

        </div>

    </div>
</template>
<script>
import { url } from '../services/url'
import {
    getHzjlList
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            type: '合作交流',
            total: 1,
            pageSize: 3,
            pageNum: 1,
            listShow: [],
            userId: localStorage.getItem('userId'),
            showList: true,
            showIndex: 0,
            getUrl: url
        }
    },
    created() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        getHzjlList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
            this.total = res.total
            this.listShow = res.rows
            loading.close()

            if (this.$route.query.item != undefined) {
                if (this.$route.query.item.id != undefined) {
                    console.log(this.$route.query.item)
                    for (let i = 0; i < this.listShow.length; i++) {
                        console.log(this.listShow[i])
                        if (this.$route.query.item.id == this.listShow[i].id) {
                            console.log(222)
                            this.toDetail(i)
                        }
                    }
                }
            }
        })

    },
    methods: {
        parseDate(item) {
            return item
        },
        changeType(type) {
            if (this.showList) {
                this.pageNum = 1
                this.type = type
                getHzjlList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                    this.total = res.total
                    this.listShow = res.rows
                    console.log(res)
                    loading.close()

                }).catch(err => {
                    loading.close()

                })
            }


        },
        getQywgetHzjlListxList(type) {
            this.pageNum = 1
            this.type = type
            getHzjlList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
                console.log(res)


            }).catch(err => {


            })

        },
        pageChange(e) {
            this.pageNum = e
            getHzjlList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
            }).catch(err => {

            })
        },
        toDetail(index) {
            this.showList = false
            this.showIndex = index
        }
    },
}
</script>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>